const w = 800;
const h = 100;
const numchars = 5;
const colors = [
    0xf85957,
    0xfcad2a,
    0x54a9fc,
    0x452fb3,
]
import * as TestJSON from "json/testSong.json";
import { SongData } from "Models/SongData";
import * as Topics from "Data/Topics";
import { TimelineLite } from "gsap";

export class MusicGameTimeline extends PIXI.Container {
    protected _graphics = this.addChild(new PIXI.Graphics());
    protected _playhead = this.addChild(new PIXI.Graphics());
    protected _songData = new SongData(TestJSON.bg.timestamps);
    protected readonly _subscriptions: any[];
    protected readonly _timeline: TimelineLite = new TimelineLite();
    protected _isPlaying: boolean = false;

    public constructor() {
        super();
        this._subscriptions = [
            PubSub.subscribe(Topics.RECORDING_UPDATED, (pTopic: string, pData: any)=>this.SetData(pData)),
            PubSub.subscribe(Topics.PLAYHEAD_MOVED, (pTopic: string, pData: any)=>this.MovePlayhead(pData)),
            // PubSub.subscribe(Topics.RECORDING_COUNT_IN, (pTopic: string, pData: any)=>this.show()),

            // PubSub.subscribe(Topics.RECORDING_ENDED, (pTopic: string, pData: any)=>this.hide()),
            PubSub.subscribe(Topics.PLAYBACK_STARTED, (pTopic: string, pData: any)=>this.Play()),
            PubSub.subscribe(Topics.PLAYBACK_ENDED, (pTopic: string, pData: any)=>this.Stop()),
        ];
        this.SetData({events:[]});
        this._playhead.clear();
        this._playhead.beginFill(0xbbbb00, 0.8);
        this._playhead.drawRect(0, 0, 5, h);
        this._playhead.endFill();
        this._playhead.position.set(-w/2, -h/2);
    }

    public destroy() {
        this._subscriptions.forEach(PubSub.unsubscribe);
        this._timeline?.kill();
        super.destroy();
    }

    public update(pDeltaTime: number) {
        if (this._isPlaying) {
            const seconds = this._songData.TimeStamps[this._songData.TimeStamps.length-1];
            const pixels = w;
            const pixelspersecond = pixels / seconds; // TODO: math???
            this._playhead.position.x += pDeltaTime * pixelspersecond;
            if (this._playhead.position.x > w/2) {
                this._playhead.position.x = -w/2;
            }
        }
    }

    public SetData(pData: {
        events: {
            time: number,
            loop: number,
            character: number,
            bar: number,
        }[]
    }) {
        const g = this._graphics;
        g.position.set(-w/2, -h/2);
        g.clear();

        // draw bg
        g.beginFill(0xbbbbbb);
        g.drawRect(0, 0, w, h);
        g.endFill();

        if(pData && pData.events) {
            // draw loops
            for (let i=0; i<pData.events.length; i++) {
                const x = (pData.events[i].time / this._songData.TimeStamps[this._songData.TimeStamps.length-1]) * w;
                const y = pData.events[i].character * h/numchars;
                const loopStart = x;
                // console.log(pData.events[i]);
                if (pData.events[i].loop === -1) {
                    if(pData.events[i].time!==0) { // TODO: prevent this junk data from being saved
                        // from here to the end
                        const loopLength = w - x;
                        g.beginFill(0xbbbbbb);
                        g.drawRect(x, y, loopLength, h/numchars);
                        g.endFill();
                    }
                }
                else {
                    // Assumes all loops are 2 bars long
                    // const loopLength = Math.min(w - x, (w / this._songData.TimeStamps.length) * 2);

                    // from here to the end
                    const loopLength = w - x;
                    g.beginFill(colors[pData.events[i].loop]);
                    g.drawRect(x, y, loopLength, h/numchars);
                    g.endFill();
                }
            }
        }

        // draw row lines
        for (let i=0; i<numchars + 1; i++) {
            const y = i * h/numchars;
            g.beginFill(0x333333);
            g.drawRect(0, y, w, 1);
            g.endFill();
        }

        // draw bar lines
        for (let i=0; i<this._songData.TimeStamps.length; i++) {
            const x = (i / this._songData.TimeStamps.length) * w;
            g.beginFill(0xbb0000);
            g.drawRect(x, 0, 2, h);
            g.endFill();
        }
    }

    public show(pAnimate: boolean = true, pCallback?: () => void): void {
        if (pAnimate) {
            this._timeline.clear();
            this.scale.set(1, 1);
            this._timeline.to(this, 0.25, {
                alpha: 1,
            });
            if (pCallback !== undefined) {
                this._timeline.call(pCallback);
            }
        }
        else {
            this.alpha = 1;
            if (pCallback !== undefined) {
                pCallback();
            }
        }
    }

    public hide(pAnimate: boolean = true, pCallback?: () => void): void {
        if (pAnimate) {
            this._timeline.clear();
            this._timeline.to(this, 0.5, {
                pixi: {
                    alpha: 0,
                },
            }, 0)
            .to(this, 0.25, {
                pixi: {
                    scaleX: 1.1,
                    scaleY: 1.1,
                },
            }, 0)
            .to(this, 0.25, {
                pixi: {
                    scaleX: 0.3,
                    scaleY: 0.3,
                },
            }, 0.25);

            if (pCallback !== undefined) {
                this._timeline.call(pCallback);
            }
        }
        else {
            this.alpha = 0;
            if (pCallback !== undefined) {
                pCallback();
            }
        }
    }

    protected MovePlayhead(pTime: number) {
        const seconds = this._songData.TimeStamps[this._songData.TimeStamps.length-1];
        const pixels = w;
        const pixelspersecond = pixels / seconds; // TODO: math???
        this._playhead.position.x = pixelspersecond * pTime -w/2;
    }

    protected Play() {
        this._isPlaying = true;
    }

    protected Stop() {
        this._isPlaying = false;
    }
}